import { useEffect, useRef, type RefObject } from "react";

/**
 * Keep a mutable ref synced to the latest value of a prop / state. Useful in
 * long-lived event handlers (SignalR subscriptions, `beforeunload` listeners,
 * setTimeout callbacks) that should read the current value without forcing
 * the handler to re-register every time the value changes.
 *
 * Replaces the repeated pattern:
 *   const fooRef = useRef(foo);
 *   useEffect(() => { fooRef.current = foo; }, [foo]);
 */
export function useLatest<T>(value: T): RefObject<T> {
  const ref = useRef(value);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref;
}
